import Decimal from 'decimal.js';
import { camposDecimalParaNumber, reduzirCasasDecimais } from './calculos';
import { calcularImpostos } from './impostos';
import * as baseComum from './comum-pessoal';
import { obterConversoes as obterConversoesBase } from './comum';

export function alpineDataInsumoPessoal(dados) {
    return {
        subTotalSalario: '0',
        subTotalImpostos: '0',
        subTotalOutros: '0',
        totalGeral: '0',
        precoPorUnidades: [],
        ...dados,

        init() {
            this.calcularImpostosEncargoSocial =
                this.calcularImpostosEncargoSocial.bind(this);
            this.calcularSubTotalSalario =
                this.calcularSubTotalSalario.bind(this);
            this.calcularImpostosRemuneracaoPessoal =
                this.calcularImpostosRemuneracaoPessoal.bind(this);
            this.calcularSubTotalImpostosRemuneracaoPessoal =
                this.calcularSubTotalImpostosRemuneracaoPessoal.bind(this);
            this.calcularSubTotalOutros =
                this.calcularSubTotalOutros.bind(this);
            this.calcularTotalGeral = this.calcularTotalGeral.bind(this);
            this.calcularPrecoPorUnidade =
                this.calcularPrecoPorUnidade.bind(this);
            this.selecionarUnidades = this.selecionarUnidades.bind(this);

            this.$watch(
                ['salarioBrutoMensal', 'empresa?.id'],
                this.calcularImpostosEncargoSocial
            );
            this.$watch(
                'aliquotasEncargoSocial',
                this.calcularImpostosEncargoSocial
            );

            this.$watch('salarioBrutoMensal', this.calcularSubTotalSalario);
            this.$watch('impostosEncargoSocial', this.calcularSubTotalSalario);

            this.$watch(
                ['subTotalSalario', 'empresa?.id'],
                this.calcularImpostosRemuneracaoPessoal
            );
            this.$watch(
                'aliquotasRemuneracaoPessoal',
                this.calcularImpostosRemuneracaoPessoal
            );

            this.$watch(
                'impostosRemuneracaoPessoal',
                this.calcularSubTotalImpostosRemuneracaoPessoal
            );

            this.$watch(
                ['beneficiosMensais', 'outro'],
                this.calcularSubTotalOutros
            );

            this.$watch(
                ['subTotalSalario', 'subTotalImpostos', 'subTotalOutros'],
                this.calcularTotalGeral
            );

            this.$watch(
                ['quantidade', 'totalGeral', 'compraUnidadeId'],
                this.calcularPrecoPorUnidade
            );

            // $watch de arrays precisa ser individual
            this.$watch(
                'conversaoUnidadeOrigemIds',
                this.calcularPrecoPorUnidade
            );
            this.$watch(
                'conversaoUnidadeDestinoIds',
                this.calcularPrecoPorUnidade
            );
            this.$watch('conversaoFatores', this.calcularPrecoPorUnidade);

            this.$watch('empresa?.unidades', this.selecionarUnidades);

            this.calcularImpostosEncargoSocial();
            this.calcularSubTotalSalario();
            this.calcularImpostosRemuneracaoPessoal();
            this.calcularSubTotalImpostosRemuneracaoPessoal();
            this.calcularSubTotalOutros();
            this.calcularTotalGeral();
            this.calcularPrecoPorUnidade();
            this.selecionarUnidades();
        },

        calcularImpostosEncargoSocial() {
            calcularImpostos({
                data: this,
                aliquotas: this.aliquotasEncargoSocial,
                campoImpostos: 'impostosEncargoSocial',
                idEmpresas: this.empresasEncargoSocial,
                idEmpresaSelecionada: this.empresa?.id,
                baseCalculo: this.salarioBrutoMensal,
            });
        },

        calcularSubTotalSalario() {
            this.subTotalSalario = baseComum
                .calcularSubTotalSalario({
                    impostosEncargoSocial: this.impostosEncargoSocial,
                    salarioBrutoMensal: this.salarioBrutoMensal,
                })
                .toNumber();
        },

        calcularImpostosRemuneracaoPessoal() {
            calcularImpostos({
                data: this,
                aliquotas: this.aliquotasRemuneracaoPessoal,
                campoImpostos: 'impostosRemuneracaoPessoal',
                idEmpresas: this.empresasRemuneracaoPessoal,
                idEmpresaSelecionada: this.empresa?.id,
                baseCalculo: this.subTotalSalario,
            });
        },

        calcularSubTotalImpostosRemuneracaoPessoal() {
            this.subTotalImpostos = baseComum
                .calcularSubTotalImpostosRemuneracaoPessoal({
                    impostosRemuneracaoPessoal: this.impostosRemuneracaoPessoal,
                })
                .toNumber();
        },

        calcularSubTotalOutros() {
            this.subTotalOutros = baseComum
                .calcularSubTotalOutros({
                    beneficiosMensais: this.beneficiosMensais,
                    outro: this.outro,
                })
                .toNumber();
        },

        calcularTotalGeral() {
            this.totalGeral = baseComum
                .calcularTotalGeral({
                    subTotalSalario: this.subTotalSalario,
                    subTotalImpostos: this.subTotalImpostos,
                    subTotalOutros: this.subTotalOutros,
                })
                .toNumber();
        },

        selecionarUnidades() {
            const buscaUnidade = (nome) =>
                this.empresa?.unidades?.find((x) =>
                    x.nome.toUpperCase().includes(nome.toUpperCase())
                );

            const unidadeHoras = buscaUnidade('HORA-HOMEM');
            this.compraUnidadeId = unidadeHoras?.id || null;

            const unidadeMinutos = buscaUnidade('MINUTO-HOMEM');
            if (unidadeHoras && unidadeMinutos) {
                this.conversaoUnidadeOrigemIds = [unidadeHoras.id];
                this.conversaoUnidadeDestinoIds = [unidadeMinutos.id];
                this.conversaoFatores = ['60'];
            } else {
                this.conversaoUnidadeOrigemIds = [];
                this.conversaoUnidadeDestinoIds = [];
                this.conversaoFatores = [];
            }
        },

        calcularPrecoPorUnidade() {
            if (
                !this.quantidade ||
                new Decimal(this.quantidade).isZero() ||
                !this.compraUnidadeId
            ) {
                this.precoPorUnidades = [];
                return;
            }

            const compra = {
                quantidade: this.quantidade,
                unidadeId: this.compraUnidadeId,
            };

            const conversoes = this.obterConversoes();

            const precoPorUnidades = [
                camposDecimalParaNumber({
                    unidadeId: this.compraUnidadeId,
                    preco: reduzirCasasDecimais(baseComum
                        .calcularPrecoPorUnidade(
                            { unidadeId: this.compraUnidadeId },
                            {
                                compra,
                                conversoes,
                                totalGeral: this.totalGeral,
                            }
                        )),
                }),
            ];

            for (
                let indiceConversao = 0;
                indiceConversao < this.conversaoUnidadeOrigemIds.length;
                indiceConversao++
            ) {
                const unidadeOrigemId =
                    this.conversaoUnidadeOrigemIds[indiceConversao];
                const unidadeDestinoId =
                    this.conversaoUnidadeDestinoIds[indiceConversao];
                const fator = this.conversaoFatores[indiceConversao];
                if (!unidadeOrigemId || !unidadeDestinoId || !fator) {
                    continue;
                }

                if (unidadeOrigemId == this.compraUnidadeId) {
                    precoPorUnidades.push(
                        camposDecimalParaNumber({
                            unidadeId: unidadeDestinoId,
                            preco: reduzirCasasDecimais(baseComum
                                .calcularPrecoPorUnidade(
                                    { unidadeId: unidadeDestinoId },
                                    {
                                        compra,
                                        conversoes,
                                        totalGeral: this.totalGeral,
                                    }
                                )),
                        })
                    );
                } else if (unidadeDestinoId == this.compraUnidadeId) {
                    precoPorUnidades.push(
                        camposDecimalParaNumber({
                            unidadeId: unidadeOrigemId,
                            preco: reduzirCasasDecimais(baseComum
                                .calcularPrecoPorUnidade(
                                    { unidadeId: unidadeOrigemId },
                                    {
                                        compra,
                                        conversoes,
                                        totalGeral: this.totalGeral,
                                    }
                                )),
                        })
                    );
                }
            }

            this.precoPorUnidades = precoPorUnidades;
        },

        rotuloPrecoPorUnidade({ unidadeId }) {
            const unidadeNome =
                this.empresa?.unidades?.find((x) => x.id == unidadeId)?.nome ??
                `unidade ${unidadeId}`;
            return `Valor ${unidadeNome}`;
        },

        obterConversoes() {
            return obterConversoesBase({
                conversaoUnidadeOrigemIds: this.conversaoUnidadeOrigemIds,
                conversaoUnidadeDestinoIds: this.conversaoUnidadeDestinoIds,
                conversaoFatores: this.conversaoFatores,
            });
        },
    };
}
